import React, { useState, useRef, useEffect } from 'react';
import { cfLogo } from '../../assets'
import { BsCaretDownFill, BsCloudLightningFill } from 'react-icons/bs';
import { RiSettings4Line, RiLogoutCircleLine } from "react-icons/ri"
import { NavLink } from 'react-router-dom';
import { deleteCookie, setCookie } from '../../helper';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase'
import {
  BellAlertIcon,
  TrashIcon,
  EyeIcon,
} from "@heroicons/react/24/outline";
import SeeAllNotification from './SeeAllNotification';
import { SelectNotification, clear_all_notification } from '../../layout/Chatbot/chatabotSlice'
import { useDispatch, useSelector } from 'react-redux';
import { selectLogInUsername, setLogInUser, SelectUserEmail } from '../authenticateDashboard/authSlice';
import { resetUniqueBnDevData, resetAuthSlice, resetChatBot, resetCouponWiseData, resetEmailSlice, resetFirstlastSlice, resetpersonaSlice, resetTrafficSlice, resetTrafficSource, resetUtmCampaign, resetutmContent, resetutmMedium, resetutmOverall, resetUtmSource, resetutmTerm, resetuniqueBooking, resetuniqueBoughtSlice, resetsessionDist, resetfacebookData } from './resetReducers';
import { checkAgentEnabled } from '../../layout/AIAgent/agentSlice';

const Header = () => {
  // const user = useSelector(selectLogInUsername);
  const email = useSelector(SelectUserEmail);

  return (
    <nav className='header backdrop-blur-md bg-black shadow-lg sticky top-0 z-20'>
      <div className="header__container flex justify-between items-center flex-wrap px-4 sm:px-6 lg:px-8 py-3">
        <div className="container__logo sm:!mx-0 mx-auto transform hover:scale-105 transition-transform duration-300">
          <img
            className="mx-auto w-48 sm:w-64 md:w-72 drop-shadow-2xl"
            src={cfLogo}
            alt="logo" />
        </div>
        <div className="container__menu sm:!mx-0 mx-auto">
          <RightMenu>
            <DropDownMenu icon={<BsCaretDownFill />} label={email ?? 'loading...'} />
          </RightMenu>
        </div>
      </div>
    </nav>
  )
}

function RightMenu({ children }) {
  return (
    <div className="rightmenu__container">{children}</div>
  )
}

function DropDownMenu({ icon, label }) {

  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false);
  const [openNotification, setOpenNotification] = useState(false)
  const [clients, setClients] = React.useState([]);
  const [clientDropdownOpen, setClientDropdownOpen] = React.useState(false);
  const adminNotifications = useSelector(SelectNotification)
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    const isAdmin = sessionStorage.getItem('userType') === 'admin';
    if (isAdmin) {
      fetch(`${process.env.REACT_SERVER_URL || 'https://server.causalfunnels.com'}/admin/all-clients`)
        .then(res => res.json())
        .then(data => {
          if (data && data.collections) setClients(data.collections || []);
        })
        .catch(err => console.warn('Failed to fetch admin clients', err));
    }
  }, []);

  function handleToggleDropDown() {
    setOpen(!open);
  }

  function handleLogout() {
    deleteCookie('user');
    signOut(auth);
    dispatch(resetAuthSlice());
    dispatch(resetChatBot());
    dispatch(resetCouponWiseData());
    dispatch(resetEmailSlice());
    dispatch(resetFirstlastSlice());
    dispatch(resetpersonaSlice());
    dispatch(resetTrafficSlice());
    dispatch(resetTrafficSource());
    dispatch(resetUtmCampaign());
    dispatch(resetutmContent());
    dispatch(resetutmMedium());
    dispatch(resetutmOverall());
    dispatch(resetUtmSource());
    dispatch(resetutmTerm());
    dispatch(resetuniqueBooking());
    dispatch(resetuniqueBoughtSlice());
    dispatch(resetsessionDist());
    dispatch(resetUniqueBnDevData());
    dispatch(resetfacebookData());
    dispatch(setLogInUser(null));
  }

  function handleNotification(action = "") {
    if (action === 'see_all') {
      setOpenNotification(prev => !prev)
    } else if (action === 'clear_all') {
      dispatch(clear_all_notification())
    }
  }

  const handleSelectClient = (client) => {
    // update cookie
    setCookie('user', client, 3);
    dispatch(checkAgentEnabled(client));
    // optionally reload or navigate
    window.location.reload();
  }

  return (
    <div className="dropdown__container flex items-center gap-4 relative" ref={dropdownRef}>
      {sessionStorage.getItem('userType') === 'admin' && (
        <div className="mr-4 inline-block relative">
          <button
            onClick={() => setClientDropdownOpen(prev => !prev)}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-gradient-to-r from-blue-600/20 to-cyan-600/20 hover:from-blue-600/30 hover:to-cyan-600/30 border border-blue-500/30 text-sm font-medium text-gray-200 hover:text-white transition-all duration-300 group"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-blue-400 group-hover:scale-110 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span>Clients</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={`w-3 h-3 text-gray-400 group-hover:text-blue-400 transition-all duration-300 ${clientDropdownOpen ? 'rotate-180' : ''}`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          <div className={`absolute right-0 mt-2 bg-black/95 backdrop-blur-xl text-white rounded-xl shadow-2xl z-50 w-72 border border-white/10 transition-all duration-300 ${clientDropdownOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2 pointer-events-none'}`}>
            <div className="p-3 border-b border-white/10">
              <div className="relative">
                <svg xmlns="http://www.w3.org/2000/svg" className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <input
                  type="text"
                  placeholder="Search clients..."
                  className="w-full bg-white/5 border border-white/10 rounded-lg py-2 pl-10 pr-4 text-sm text-gray-200 placeholder-gray-500 focus:outline-none focus:border-blue-500/50 focus:ring-1 focus:ring-blue-500/30 transition-all"
                  onChange={(e) => {
                    const searchTerm = e.target.value.toLowerCase();
                    const items = document.querySelectorAll('.client-item');
                    items.forEach(item => {
                      const text = item.textContent.toLowerCase();
                      item.style.display = text.includes(searchTerm) ? 'flex' : 'none';
                    });
                  }}
                />
              </div>
            </div>
            <div className="max-h-64 overflow-auto py-2 px-2 custom-scrollbar">
              {clients.length === 0 ? (
                <div className="text-center py-4 text-gray-500 text-sm">No clients found</div>
              ) : (
                clients.map(c => (
                  <div
                    key={c}
                    className="client-item flex items-center gap-3 px-3 py-2.5 hover:bg-gradient-to-r hover:from-blue-600/20 hover:to-cyan-600/20 cursor-pointer rounded-lg transition-all duration-200 group"
                    onClick={() => handleSelectClient(c)}
                  >
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold text-xs shadow-lg flex-shrink-0">
                      {c?.charAt(0)?.toUpperCase() || 'C'}
                    </div>
                    <span className="text-sm text-gray-300 group-hover:text-white transition-colors truncate">{c}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-600 group-hover:text-blue-400 ml-auto opacity-0 group-hover:opacity-100 transition-all" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                ))
              )}
            </div>
            <div className="p-2 border-t border-white/10 text-center">
              <span className="text-xs text-gray-500">{clients.length} client{clients.length !== 1 ? 's' : ''} available</span>
            </div>
          </div>
        </div>
      )}
      <div className="dropdown__label flex items-center gap-3 cursor-pointer select-none px-4 py-2.5 rounded-xl bg-white/5 hover:bg-white/10 transition-all duration-300 group" onClick={handleToggleDropDown}>
        <div className='flex gap-2 items-center'>
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500 flex items-center justify-center text-white font-bold text-sm shadow-lg">
            {label?.charAt(0)?.toUpperCase() || 'U'}
          </div>
          <span className="dropdown__label--text text-gray-200 font-medium text-sm group-hover:text-white transition-colors truncate max-w-[150px]">{label}</span>
          {/* {adminNotifications?.length ? (<span className='text-white bg-red-500 rounded-full p-1 px-2'>{adminNotifications.length}</span>):null}  */}
        </div>
        <span className={`dropdown__label--icon transition-all duration-500 text-gray-400 group-hover:text-blue-400 ${open && '-rotate-180'}`}>{icon}</span>
      </div>
      <div className={`dropdown__menu absolute right-0 mt-2 rounded-xl shadow-2xl overflow-hidden transition-all duration-300 ${open ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2 pointer-events-none'}`}>
        {/* <SeeAllNotification open={openNotification} setOpen={setOpenNotification} NotificationObj={adminNotifications} /> */}
        <ul className="dropdown__menu--list py-2 bg-black backdrop-blur-xl text-neutral-200 min-w-[220px]">
          <li className="px-4 py-2">
            <p className="text-xs text-gray-400 font-semibold uppercase tracking-wider">Account</p>
          </li>
          <MenuItem icon={<RiSettings4Line />} label='Settings' link="/settings" />

          {/* <button  className="block dropdown__menu--item cursor-pointer py-1 px-8 hover:bg-[#213c6c] hover:dark:bg-[#213c6c]" >
            <div className="flex items-center gap-2 ">
              <span className="dropdown__menu--item-icon scale-150">< BellAlertIcon className='text-white w-5 h-4'/></span>
              <span className="dropdown__menu--item-label"> Notification({adminNotifications.length})</span>
            </div>
            <div className='flex flex-col gap-1 pl-5'>
            <div className="flex items-center gap-2 cursor-pointer hover:font-bold" onClick={() => handleNotification('see_all')}>
              <span className="dropdown__menu--item-icon scale-150">< EyeIcon className='text-white w-4 h-3'/></span>
              <span className="dropdown__menu--item-label">See All</span>
              </div>
            <div className="flex items-center gap-2 cursor-pointer hover:font-bold " onClick={()=>handleNotification('clear_all')}>
              <span className="dropdown__menu--item-icon scale-150">< TrashIcon className='text-white w-4 h-3'/></span>
              <span className="dropdown__menu--item-label">Clear All</span>
              </div>
            
              </div>
          </button> */}
          <li className="px-2 pt-2">
            <button onClick={handleLogout} className="w-full dropdown__menu--item cursor-pointer py-2.5 px-4 hover:bg-red-500/10 hover:text-red-400 rounded-lg transition-all duration-200 group" >
              <div className="flex items-center gap-3">
                <span className="dropdown__menu--item-icon text-lg group-hover:scale-110 transition-transform"><RiLogoutCircleLine /></span>
                <span className="dropdown__menu--item-label font-medium text-sm">Logout</span>
              </div>
            </button>
          </li>
        </ul>
      </div>
    </div>
  )
}

function MenuItem({ icon, label, link }) {
  return (
    <li className="px-2">
      <NavLink className="dropdown__menu--item cursor-pointer flex py-2.5 px-4 hover:bg-white/10 hover:text-white rounded-lg transition-all duration-200 group" to={link}>
        <div className="flex items-center gap-3">
          <span className="dropdown__menu--item-icon text-lg text-gray-400 group-hover:text-blue-400 group-hover:scale-110 transition-all">{icon}</span>
          <span className="dropdown__menu--item-label font-medium text-sm">{label}</span>
        </div>
      </NavLink>
    </li>
  )
}

export default Header